import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { CargaMasiva } from "models/ECF/CargaMasiva";
import { useTheme } from "hooks/useTheme";

/**
 * Paso 1: Selección de entidad.
 * Muestra una card por cada entidad disponible para carga masiva.
 * Props:
 *   onSeleccionar(entidadValue) - callback al seleccionar
 */
const EntidadSelector = ({ onSeleccionar }) => {
  const entidades = CargaMasiva.ENTIDADES;
  const { theme } = useTheme();

  return (
    <div>
      <p className="text-muted mb-4">
        Seleccione el tipo de datos que desea cargar masivamente.
      </p>
      <Row>
        {entidades.map((entidad) => (
          <Col key={entidad.value} md={6} lg={3} className="mb-3">
            <Card
              className="h-100 border"
              style={{ cursor: "pointer", transition: "box-shadow 0.2s, border-color 0.2s" }}
              onClick={() => onSeleccionar(entidad.value)}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = `0 4px 16px ${theme.color1}40`;
                e.currentTarget.style.borderColor = theme.color1;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.borderColor = "";
              }}
            >
              <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center p-4">
                <i
                  className={entidad.icono}
                  style={{ fontSize: "2.5rem", marginBottom: "12px", color: theme.color1 }}
                />
                <Card.Title className="mb-1" style={{ fontSize: "1rem", fontWeight: 600 }}>
                  {entidad.label}
                </Card.Title>
                <Card.Text className="text-muted" style={{ fontSize: "0.82rem" }}>
                  {entidad.descripcion}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EntidadSelector;
